// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f399dd45","453":"ed583018","455":"43187235","977":"2e318801"}[chunkId] + ".chunk.js";
};